// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_SF-","cls2":"common-cls2_krM common-cls1_SF-"};